const availableSizes = [
    // mobile small thumbs on different devices with pixelRatio
    420,
    480,
    // temporary disabled
    // 560,

    // mobile big thumbs on different devices with pixelRatio
    // temporary disabled
    // 420 * 2,
    // 480 * 2,
    // 560 * 2,

    // icon thumb on different devices with pixelRatio
    90,

    // desktop small thumbs @1
    160,
    190,

    // desktop big thumbs @1 + desktop small thumbs @2
    160 * 2,
    190 * 2,

    // desktop big thumbs @2
    // temporary disabled
    // 160 * 4,
    // 190 * 4,
].sort((a, b) => b - a) // sort descending

// const playgamaThumbsPrefix = 'https://playgama.com/cdn-cgi/imagedelivery/'
// experiment, testing the impact on perf instruments
// TODO: DEV-2630 migrate from on-demand transformations to pre-defined in cloudflare
const playgamaThumbsPrefix = 'TEMPORARY_DISABLE_TRANSFORMATIONS'
const playgamaThumbsSuffix = '/enlarged'
const playgamaIconThumbsSuffix = '/thumb'
const suffixPattern = `(${[playgamaThumbsSuffix, playgamaIconThumbsSuffix].join('|')})$`
const suffixRegex = new RegExp(suffixPattern)

const replaceThumbUrl = (src: string, desiredWidth: number) => {
    const closestSize = availableSizes.find((size) => size <= desiredWidth) || availableSizes.at(-1)
    let quality = 75
    if (!closestSize || closestSize <= 160) {
        quality = 50
    }

    return src.replace(suffixRegex, `/width=${closestSize},quality=${quality}`)
}

export const processThumbSrc = (src: string, desiredWidth: number) => {
    if (!src.startsWith(playgamaThumbsPrefix) || !suffixRegex.test(src)) {
        return src
    }

    return replaceThumbUrl(src, desiredWidth)
}

export const processThumbSrcset = (src: string, desiredWidth: number) => {
    if (!src.startsWith(playgamaThumbsPrefix) || !suffixRegex.test(src)) {
        return ''
    }
    // 1.75 is google page insights pixelratio, serve 1x there on purpose
    return `${replaceThumbUrl(src, desiredWidth)}, ${replaceThumbUrl(src, desiredWidth)} 1.75x, ${replaceThumbUrl(src, desiredWidth * 2)} 2x, ${replaceThumbUrl(src, desiredWidth * 3)} 3x`
}

export const getThumbUrlFromOriginal = (src: string) => {
    return src.replace(/\/original$/, playgamaThumbsSuffix)
}
